/**
 * @generated SignedSource<<5f0219ef69e017c0e062a78c0479b083>>
 * @relayHash b2979c7cdb495363844387e7ca70adab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b7a1ec5233246939ca5d1e47156b6777dfd302edb1f892f73f595aecfdb1c2b5

import type { ConcreteRequest } from 'relay-runtime';
export type AccessStatus = "ANONYMOUS_ACCESS" | "EXTERNAL_COLLABORATOR_ACCESS" | "EXTERNAL_SHARE_ACCESS" | "LICENSED_ADMIN_ACCESS" | "LICENSED_USE_ACCESS" | "NOT_PERMITTED" | "UNLICENSED_AUTHENTICATED_ACCESS" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type UnifiedUserQuery$variables = Record<PropertyKey, never>;
export type UnifiedUserQuery$data = {
  readonly currentConfluenceUser: {
    readonly isAnonymous: boolean;
  } | null | undefined;
  readonly hasUserAccessAdminRole: boolean | null | undefined;
  readonly isNewUser: boolean | null | undefined;
  readonly isSiteAdmin: boolean | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly accessStatus: AccessStatus;
      readonly accountId: string | null | undefined;
      readonly locale: string;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined>;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly userKey: string | null | undefined;
    } | null | undefined;
    readonly displayName: string | null | undefined;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly timeZone: string | null | undefined;
  } | null | undefined;
  readonly userCanCreateContent: boolean | null | undefined;
};
export type UnifiedUserQuery = {
  response: UnifiedUserQuery$data;
  variables: UnifiedUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "hasUserAccessAdminRole"
  },
  {
    "kind": "ScalarField",
    "name": "userCanCreateContent"
  },
  {
    "kind": "ScalarField",
    "name": "isNewUser"
  },
  {
    "concreteType": "CurrentConfluenceUser",
    "kind": "LinkedField",
    "name": "currentConfluenceUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isAnonymous"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "kind": "ScalarField",
        "name": "timeZone"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": (v1/*: any*/)
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": (v1/*: any*/)
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "accessStatus"
          },
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "userKey"
          },
          {
            "kind": "ScalarField",
            "name": "locale"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UnifiedUserQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnifiedUserQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b2979c7cdb495363844387e7ca70adab",
    "id": "b7a1ec5233246939ca5d1e47156b6777dfd302edb1f892f73f595aecfdb1c2b5",
    "metadata": {},
    "name": "UnifiedUserQuery",
    "operationKind": "query",
    "text": "query UnifiedUserQuery{isSiteAdmin,hasUserAccessAdminRole,userCanCreateContent,isNewUser,currentConfluenceUser{isAnonymous},user:confluence_atlassianUser(current:true){id,displayName,timeZone,photos{value,isPrimary},emails{value,isPrimary},confluence{permissionType,space{id},operations{operation,targetType},accessStatus,accountId,userKey,locale}}}"
  }
};
})();

(node as any).hash = "587fceb239a4e30f4440f813cd8683f5";

export default node;
